
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import StockOrderModule from "@/store/modules/barcodeSystem/stockOrder";
import { StockOrderItemListItem } from "@/models/api/barcodeSystem/stockOrders/get";
import { formatDateWithTime, formatBool, formatUoMQuantity } from "@/utils";
import { StockSkuResource } from '@/models/api/barcodeSystem/stockSkus/stockSkus';

const barcodeOrderModuleState = getModule(StockOrderModule);

@Component
export default class StockOrderItemTable extends Vue {
  @Prop({ default: false })
  loading: boolean;

  get stockOrderItems(): Array<StockOrderItemListItem> {
    return barcodeOrderModuleState.currentStockOrderItems;
  }

  get selectedItemCount(): number {
    return barcodeOrderModuleState.getSelectedStockOrderItemCount;
  }

  get selectedItems(): Array<any> {
    return barcodeOrderModuleState.getSelectedStockOrderItems;
  }

  get totalItems() {
    if (barcodeOrderModuleState.currentStockOrderItems) {
      return barcodeOrderModuleState.currentStockOrderItems.length
    } else {
      return 0;
    }
  }
 

  getDamagedMessage(orderItem) : string {
    let damageMessage = formatBool(orderItem.isDamaged);
    if(orderItem && orderItem.isDamaged) {
      if(orderItem.damageCode)
        damageMessage = damageMessage + ' ' + orderItem.damageCode + '';
      damageMessage = damageMessage + '(' + orderItem.quantityDamaged + ')';
    }
    return damageMessage;
  }

  getComponentData(rowData) {
    return {
      on: {
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }

  formatDateWithTime(val)
  {
    return formatDateWithTime(val)
  }

  formatBool(val)
  {
    return formatBool(val);
  }

  formatUoMQuantity(val: number, stockSku: StockSkuResource) {
    return formatUoMQuantity(val, stockSku);
  }

  onDoubleClicked(data) {
  }

  onRowClick(data) {
    barcodeOrderModuleState.switchStockOrderItemSelectionStatus(data.id);
  }

  unselectAll() {
    let items = this.selectedItems;

    items.forEach(item => {
      barcodeOrderModuleState.switchStockOrderItemSelectionStatus(item.id);
    });
  }

}
